import { z } from 'zod';

/** `POST /api/feedback` body (docs/superpowers/specs/2026-08-18-feedback-form-design.md).
 * `context` only carries the client-observable half (`path`/`botId`) — `userAgent` is
 * appended server-side from the request header, never accepted from the client. */
export const feedbackCreateSchema = z.object({
  type: z.enum(['bug', 'feature', 'question']),
  message: z.string().min(1).max(5000),
  context: z
    .object({
      path: z.string().max(300).optional(),
      botId: z.string().max(50).optional(),
    })
    .optional(),
});

export type FeedbackCreateInput = z.infer<typeof feedbackCreateSchema>;

/** `POST /api/admin/feedback/:id/handled` body — always states the full desired value, same
 * idempotent-toggle convention as `setWorkspaceInternalSchema`. */
export const adminFeedbackHandledSchema = z.object({
  handled: z.boolean(),
});

export type AdminFeedbackHandledInput = z.infer<typeof adminFeedbackHandledSchema>;
